export default {
  name: 'FeatureMixin',
  data() {
    return {}
  },
  computed: {
    /**
     * Computed property to access company features from Vuex store.
     * @returns {Array} - Array of company features.
     */
    companyFeatures() {
      return this.$store.state?.applicationState?.currentProject?.features || []
    }
  },
  methods: {
    /**
     * Checks if the company has a specific feature.
     * @param {string} featureName - The name of the feature to check.
     * @returns {boolean} - Returns true if the company has the feature, otherwise false.
     */
    hasFeature(featureName) {
      return this.companyFeatures.some(feature => feature.name === featureName && feature.is_activated)
    },

    /**
     * Checks if the company has ALL specified features.
     * @param {string[]} permissionNames - An array of feature names to check.
     * @returns {boolean} - Returns true if the user has all the specified features, otherwise false.
     */
    hasAllFeatures(featureNames) {
      return featureNames.every(name => this.hasFeature(name))
    },

    /**
     * Checks if the user has ANY of the specified features.
     * @param {string[]} permissionNames - An array of feature names to check.
     * @returns {boolean} - Returns true if the company has at least one of the specified features, otherwise false.
     */
    hasAnyFeatures(featureNames) {
      return featureNames.some(name => this.hasFeature(name))
    }
  }
}
